

const drawingV2 = {
    results: [],
    rightResults: [],
    slotResults: []
}
const drawingSc = {
    results: [
        {
            "postCode": "A",
            "number": "42466"
        },
        {
            "postCode": "B",
            "number": "?????"
        },
        {
            "postCode": "C",
            "number": "34534"
        },
        {
            "postCode": "D",
            "number": "45654"
        },
        {
            "postCode": "D",
            "number": "25443"
        }
    ],
}

const drawingKh = {
    results: [
        {
            "postCode": "A",
            "number": "67387"
        },
        {
            "postCode": "B",
            "number": "?????"
        },
        {
            "postCode": "C",
            "number": "34436"
        },
        {
            "postCode": "D",
            "number": "45645"
        }
    ],
}

const configMt = {
    type: 'mt',
    loading: {
        width: "15px"
    },
    background: "#fff",
    hlBG: "#F3F3F3",
    random: {
        background: "#eaffd5", borderRadius: "50%",
        padding: "0 2px",
        border: "1px solid #a4ffbb",
        letterSpacing: 0,
        lineHeight: 1,
    },
    row: {
        row_0: {
            normal: {
                fontSize: "45px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.4
            }, loading: {
                width: "20px"
            }, random: {
                fontSize: "45px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
            }
        }, row_8: {
            normal: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.17
            }, loading: {
                width: "18px"
            }, random: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.3
            }
        }
    },
    hlIndex: [1, 3, 5],
    ng: {
        loading: {
            width: "20px"
        },
        hlIndex: [1, 3, 5, 7],
        row: {
            row_0: {
                normal: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "28px"
                }, random: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4,
                    padding: "0 3px"
                }
            },
            row_1: {
                normal: {
                    fontSize: "45px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "22px"
                },
                random: {
                    fontSize: "45px",
                    fontWeight: "900",
                }
            },
            row_6: {
                normal: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "23px",
                    marginTop: "10px"
                },
                random: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                }
            },
            row_7: {
                normal: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "25px",
                    marginTop: "18px"
                }, random: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }
            }
        },
    }
};

const configLeap = {
    postToIndex: {
        A: 0, B: 1, C: 3, D: 5, F: 2, I: 4, N: 6
    },
    iToCol: {
        1: 3, 2: 6,
    },
    style: {
        postLabel: {
            width: "35px", color: "#FA0000", fontFamily: "Arial Black, sans-serif"
        }, container: {
            width: "50%",
            height: "100%",
            background: "#FFEDB2",
            border: "10px solid #FAC413",
            borderTopRightRadius: "40px",
            borderBottomRightRadius: "40px"
        }, row_0: {
            borderTop: 0, fontSize: "55px", borderBottom: "2px solid #3892DD", color: "#46C3DB"
        }, row_1: {
            color: "#482FF7",
        }, row_2: {
            // textAlign:"start",
            fontSize: "40px", // borderTop: "2px solid #3892DD",
            color: "#02C753", padding: 0,
        }, row_2_child: {
            padding: "0", height: "100px", borderTop: "2px solid #3892DD", borderRight: "2px solid #3892DD",
        }, row_2_child_num: {
            width: "300px", display: "flex", marginLeft: "60px", fontSize: "45px"
        }, row_0_child_num: {
            width: "330px", display: "flex", marginLeft: "60px", fontSize: "55px"
        }, random: {
            background: "#EBFAD3", border: "1px solid #31d800",
            marginRight: "1px", borderRadius: "50%",
            padding: "0 1px 0 3px"
        }, loading: {
            width: "25px", paddingBottom: "10px"
        },
        resultItem: {
            lineHeight: 1,
            height: "95px",
            fontSize: "65px",
            color: "#02C753",
            marginBottom: "12px"
        },
        resultChild: {
            width: "151px",
            textAlign: "center",
            marginRight: "42px"
        },
        result3d: {
            // margin: "0 30px",
        }

    }
}

const configSc = {
    style: {
        wrapper: {
            width: "100%",
            height: "766px",
            backgroundImage: `url(${require(`../assets/images/live-v2/sc/bg.jpg`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            letterSpacing: "12px"
        },
        container: {
            position: "relative",
            height: "766px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${require(`../assets/images/live-v2/sc/drawing.png`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%"
        },
        container2: {
            height: "766px",
            width: "100%",
            backgroundSize: "100% 100%",
            backgroundImage: `url(${require(`../assets/images/live-v2/sc/post.png`)})`,
        },
        drawing: {
            color: "#003CFF",
            fontSize: "110px",
            fontWeight: "bold",
            height: "118px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            letterSpacing: "30px",
            marginLeft: "38px"
        },
        random: {
            color: "#003CFF",
            fontSize: "110px",
            fontWeight: "bold",
            height: "118px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "30px",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }

    }
}
const configTC = {
    type: 'tn',
    loading: {
        width: "15px",
        marginBottom: "5px"
    },
    background: "#fff",
    hlBG: "#F3F3F3",
    random: {
        background: "#eaffd5", borderRadius: "50%",
        padding: "0 2px",
        border: "1px solid #a4ffbb",
        letterSpacing: 0,
        lineHeight: 1,
    },
    row: {
        row_0: {
            normal: {
                fontSize: "45px",
                color: "#930001",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1,
            }, loading: {
                width: "20px"
            }, random: {
                fontSize: "45px",
                color: "#930001",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.3,
                borderRadius: "50%",
                border: "1px solid #a4ffbb",
                letterSpacing: 0,
                padding: "0 2px",

            }
        }, row_8: {
            normal: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.17
            }, loading: {
                width: "20px"
            }, random: {
                fontSize: "34px",
                color: "#930001",
                lineHeight: 1.5,
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                borderRadius: "50%",
                border: "1px solid #a4ffbb",
                letterSpacing: 0,
                padding: "0 2px",

            }
        }
    },
    hlIndex: [1, 3, 5],
    ng: {
        loading: {
            width: "20px"
        },
        hlIndex: [1, 3, 5, 7],
        row: {
            row_0: {
                normal: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "28px",
                }, random: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_1: {
                normal: {
                    fontSize: "45px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "22px"
                },
                random: {
                    fontSize: "45px",
                    fontWeight: "900",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_6: {
                normal: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "23px",
                    marginTop: "10px"
                },
                random: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                    paddingLeft: "1px",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_7: {
                normal: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "25px",
                    marginTop: "18px"
                }, random: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                    lineHeight: 1.4
                }
            }
        },
    }
};

const slotConfs = {
    random: {
        background: "#FEDC00", borderRadius: "8px", paddingLeft: "1px", color: "#DD0000"
    },
    slot: {
        slot_gap_6: {
            gap: "1px"
        },
        slot_6: {
            paddingLeft: "5px",
            width: "23px",
            fontSize: "2.8rem"
        },
        slot_gap_5: {
            gap: ".8px"
        },
        slot_5: {
            paddingLeft: "4.5px",
            width: "28px",
            fontSize: "3.2rem"
        },
        slot_gap_4: {
            gap: "2px"
        },
        slot_4: {
            paddingLeft: "5px",
            width: "34px",
            fontSize: "3.8rem"
        },
        slot_gap_3: {
            gap: "2.5px"
        },
        slot_3: {
            paddingLeft: "5px",
            width: "46px",
            fontSize: "4.5rem"
        },
        slot_gap_2: {
            gap: "0px"
        },
        slot_2: {
            paddingLeft: "5px",
            width: "72px",
            fontSize: "4.8rem",
            paddingTop: "1px"
        }
    },
    ng: {

        slot: {
            slot_gap_6: {
                gap: "1px"
            },
            slot_6: {
                paddingLeft: "5px",
                width: "60px",
                fontSize: "5rem",
                paddingBottom: '1px'
            },
            slot_gap_5: {
                gap: "0px"
            },
            slot_5: {
                paddingLeft: "5px",
                width: "75px",
                fontSize: "6rem",
                paddingBottom: '1px'
            },
            slot_gap_4: {
                gap: "3px"
            },
            slot_4: {
                paddingLeft: "5px",
                width: "90px",
                fontSize: "6rem",
                paddingBottom: '2px'
            },
            slot_gap_3: {
                gap: "0px"
            },
            slot_3: {
                paddingLeft: "5px",
                width: "125px",
                fontSize: "6rem",
                paddingBottom: '0px'
            },
            slot_gap_2: {
                gap: "1px"
            },
            slot_2: {
                paddingLeft: "5px",
                width: "190px",
                fontSize: "6rem",
                paddingBottom: '2px'
            }
        },
    }

}

const configKp = {
    type: 'kp',
    background: "#FFFFFF",
    hlBG: "#D4D4D4",
    row_0: "#2C0339",
    random: {
        background: "#FEDC00", borderRadius: "8px", paddingLeft: "1px", color: "#DD0000"
    },
    row: {
        row_0: {
            normal: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.4
            }, loading: {
                width: "18px"
            }, random: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                borderRadius: "15px",
                paddingLeft: "1px",
            }
        }, row_8: {
            normal: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.17
            }, loading: {
                width: "18px"
            }, random: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                borderRadius: "15px",
                paddingLeft: "1px",
            }
        }
    },
    hlIndex: [2, 4],
    bcdCode: ["B", "C", "D"],
    threeRows: ["A", "F", "I", "B", "C", "D", "N", "M", "L", "P", "U", "T"],
    fourRows: ["A", "F", "I", "J", "B", "C", "D", "N", "P", "Q"],
    row_post_0: {
        marginTop: "72px"
    },
    row_post_1: {
        marginTop: "80px",
        color: "#501900"
    },
    row_post_2: {
        marginTop: "80px"
    },
    row_post3_0: {
        marginTop: "50px"
    },
    row_post3_1: {
        marginTop: "56px",
        color: "#501900"
    },
    row_post3_2: {
        marginTop: "55px"
    },
    row_post3_3: {
        marginTop: "54px"
    },
    row_post_height: {
        height: "172px"
    },
    row_post3_height: {
        height: "134px"
    },
    row_post_3num_0: {
        height: "63px",
        marginBottom: "5px",
        marginLeft: "6px",
        width: "260px",
    },
    row_post_3num_1: {
        height: "63px",
        marginBottom: "5px",
        marginLeft: "6px",
        width: "260px",
    },
    row_post_3num_2: {
        height: "63px",
        marginBottom: "5px",
        marginLeft: "6px",
        width: "260px",
    },
    row_post_3num_3: {
        height: "63px",
        marginBottom: "5px",
        marginLeft: "6px",
        width: "258px",
    },
    row_post_num_0: {
        height: "78px",
        marginBottom: "12px",
        marginLeft: "6px",
        width: "195px",
    },
    row_post_num_1: {
        height: "80px",
        marginBottom: "12px",
        marginLeft: "6px",
        width: "260px",
    },
    row_post_num_2: {
        height: "80px",
        marginBottom: "12px",
        marginLeft: "6px",
        width: "260px",
    },
    ng: {
        hlIndex: [1, 3, 5, 7],
        row_box_1: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        row_box_2: {
            height: "100%",
            width: '50%',
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        row_box_3: {
            width: '50%',
            height: `100%`,
        },
        row_box_4: {
            width: '50%',
            height: `100%`,
        },
        row_box_5: {
            width: '50%',
            height: `100%`,
        },
        ml_a: {
            marginLeft: "19px"
        },
        height_a_twoD: {
            height: "116px",
            width: "185px",
            marginLeft: "11px"
        },
        height_a_threeD: {
            height: "116px",
            width: "250px",
            marginLeft: "10px"
        },
        post_a_twoD: {
            fontSize: "90px",
            height: "116px"
        },
        post_a_threeD: {
            fontSize: "90px",
            marginTop: "10px",
            height: "116px"
        },
        post_bcd: {
            marginRight: "23px",
            width: "242px",
            height: "112px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        row_item_3: {
            height: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        row_item_4: {
            height: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        row_item_5: {
            height: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        row: {
            row_td_1: { height: "98px" },
            row_td_2: { height: "73.5px" },
            row_td_3: { height: "145.5px" },
            row_td_4: { height: "145.5px" },
            row_td_5: { height: "145.5px" },
            row_0: {
                normal: {
                    fontSize: "45px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "23px"
                }, random: {
                    fontSize: "45px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    borderRadius: "15px",
                    paddingLeft: "1px",
                    lineHeight: 1.4
                }
            },
            row_1: {
                normal: {
                    fontSize: "55px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "28px"
                },
                random: {
                    fontSize: "55px",
                    fontWeight: "900",
                    borderRadius: "15px",
                    paddingLeft: "1px",
                }
            },
            row_6: {
                normal: {
                    color: "#110FFF",
                    fontSize: "40px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "20px",
                },
                random: {
                    color: "#110FFF",
                    fontSize: "40px",
                    fontWeight: "900",
                    borderRadius: "15px",
                    paddingLeft: "1px",
                }
            },
            row_7: {
                normal: {
                    fontSize: "40px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "20px",
                }, random: {
                    fontSize: "40px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    borderRadius: "15px",
                    paddingLeft: "1px",
                    lineHeight: 1.4
                }
            }
        },
    }
};

const config3 = {
    ...configKp,
    tbH: "660px",
    tdH: "30px",
    table: {
        td: {
            fontSize: "30px",
        }
    },
    ng: {
        ...configKp.ng,
        row: {
            ...configKp.ng.row,
            row_td_1: { height: "88px" },
            row_td_2: { height: "63.5px" },
            row_td_3: { height: "135.5px" },
            row_td_4: { height: "120.5px" },
            row_td_5: { height: "120.5px" },
        }
    }
};

const configLeap3 = {
    ...configLeap,
    style: {
        ...configLeap.style,
        container: {
            width: "50%",
            height: "100%",
            background: "#1F64FB",
            borderRadius: "20px",
            marginLeft: "15px",
        },
        resultItem: {
            lineHeight: 1,
            height: "80px",
            fontSize: "65px",
            color: "#02C753",
            marginBottom: "12px",
        },
        resultChild: {
            width: "145px",
            textAlign: "center",
            marginRight: "40px",
        },
        row_1: {
            color: "#FFE338",
        }
    }
}



export {
    drawingV2, drawingSc,
    drawingKh, configMt,
    configLeap, configSc,
    configTC, configKp,
    config3, configLeap3,
    slotConfs
}